import { css } from 'aphrodite';
import { DateInput } from '../../../web/components-v2/DateInput';
import { Input } from '../../../web/components-v2/Input';
import type { RepCardFilters } from './repCardFilters';
import { styleSheet } from './repCards.styles';

interface IProps {
	filters: RepCardFilters;
	onChange: (filters: RepCardFilters) => void;
}

export function RepCardFilterBar({ filters, onChange }: IProps) {
	const set = (patch: Partial<RepCardFilters>) => onChange({ ...filters, ...patch });

	return (
		<div className={css(styleSheet.filters)}>
			<div className={css(styleSheet.filterRow)}>
				<span className={css(styleSheet.filterLabel)}>Score</span>
				<Input
					type='number'
					min={0}
					max={100}
					inputMode='numeric'
					placeholder='Min'
					aria-label='Minimum adherence score'
					value={filters.minScore}
					onChange={e => set({ minScore: e.target.value })}
					styles={[styleSheet.filterRangeInput]}
				/>
				<span className={css(styleSheet.filterRangeSep)} aria-hidden='true'>
					–
				</span>
				<Input
					type='number'
					min={0}
					max={100}
					inputMode='numeric'
					placeholder='Max'
					aria-label='Maximum adherence score'
					value={filters.maxScore}
					onChange={e => set({ maxScore: e.target.value })}
					styles={[styleSheet.filterRangeInput]}
				/>
			</div>
			<div className={css(styleSheet.filterRow)}>
				<span className={css(styleSheet.filterLabel)}>Length</span>
				<Input
					type='number'
					min={0}
					inputMode='numeric'
					placeholder='Min'
					aria-label='Minimum call length in minutes'
					value={filters.minMinutes}
					onChange={e => set({ minMinutes: e.target.value })}
					styles={[styleSheet.filterRangeInput]}
				/>
				<span className={css(styleSheet.filterRangeSep)} aria-hidden='true'>
					–
				</span>
				<Input
					type='number'
					min={0}
					inputMode='numeric'
					placeholder='Max'
					aria-label='Maximum call length in minutes'
					value={filters.maxMinutes}
					onChange={e => set({ maxMinutes: e.target.value })}
					styles={[styleSheet.filterRangeInput]}
				/>
				<span className={css(styleSheet.filterRangeSep)} aria-hidden='true'>
					min
				</span>
			</div>
			<div className={css(styleSheet.filterRow)}>
				<span className={css(styleSheet.filterLabel)}>Date</span>
				<DateInput value={filters.startDate} onChange={value => set({ startDate: value })} />
				<DateInput value={filters.endDate} onChange={value => set({ endDate: value })} />
			</div>
		</div>
	);
}
